import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faPenToSquare,
  faDownload,
  faEye,
  faTrash,
  faSquarePlus,
  faCalendarDays,
  faDollarSign,
  faEnvelope,
  faRotateRight,
  faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import { faNoteSticky } from '@fortawesome/free-regular-svg-icons';
import { type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { ButtonComponent } from '@shared/components/button';
import { type ButtonIcons } from './types';

@Component({
  selector: 'icon-button',
  standalone: true,
  imports: [FontAwesomeModule, ButtonComponent],
  templateUrl: './icon-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconButtonComponent {
  icon = input.required<ButtonIcons>();

  label = input<string>('');
  variant = input<'primary' | 'secondary' | 'tertiary'>('primary');
  size = input<'sm' | 'md'>('sm');
  class = input<string>('');
  fitContent = input<boolean>(true);
  disabled = input<boolean>(false);
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  onClick = output<MouseEvent>();

  readonly iconMap: Record<ButtonIcons, IconDefinition> = {
    pen: faPenToSquare,
    eye: faEye,
    trash: faTrash,
    plus: faSquarePlus,
    calendar: faCalendarDays,
    dollar: faDollarSign,
    note: faNoteSticky,
    envelope: faEnvelope,
    refresh: faRotateRight,
    check: faCircleCheck,
    download: faDownload,
  };
}
